//https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8182/publication/ope/24208

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Publication } from "src/app/models/Publication";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
  })
  export class opePublication {

    constructor(private http: HttpClient){}

    BASE_PATH_PUBLICATIONBYID = "/programmes-lots/publication/ope/";

    getPublicationOpe =(numOpe: number): Observable<Publication[]> => {
        
        const url = `${environment.host.domaine + this.BASE_PATH_PUBLICATIONBYID}`;
        return this.http.get<Publication[]>(url+numOpe);

    }
    
  }